import { render, staticRenderFns } from "./ReferenceDetailsSection.vue?vue&type=template&id=f6fee756&scoped=true&"
import script from "./ReferenceDetailsSection.vue?vue&type=script&lang=js&"
export * from "./ReferenceDetailsSection.vue?vue&type=script&lang=js&"
import style0 from "./ReferenceDetailsSection.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ReferenceDetailsSection.vue?vue&type=style&index=1&id=f6fee756&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6fee756",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDivider,VIcon})
